module.exports = __webpack_public_path__ + "checkbox-sign-in-widget@2x.c8c027005764d43d83566d88f53844c9.png";